import { Channel } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useChannels = (
  projectId: string,
  options: Omit<UseSuspensePaginatedQueryOptions<Channel>, "queryKey" | "url"> = {},
) => {
  return useSuspensePaginatedQuery<Channel>({
    queryKey: ["projects", projectId, "channels"],
    url: `/projects/${projectId}/channels`,
    ...options
  });
};
